import createIcon from '../../createIcon';

/**
 * @component @name QrCodeScanner
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDYuNVY5LjVINi41VjYuNUg5LjVaTTExIDVINVYxMUgxMVY1Wk05LjUgMTQuNVYxNy41SDYuNVYxNC41SDkuNVpNMTEgMTNINVYxOUgxMVYxM1pNMTcuNSA2LjVWOS41SDE0LjVWNi41SDE3LjVaTTE5IDVIMTNWMTFIMTlWNVpNMTMgMTNIMTQuNVYxNC41SDEzVjEzWk0xNC41IDE0LjVIMTZWMTZIMTQuNVYxNC41Wk0xNiAxM0gxNy41VjE0LjVIMTZWMTNaTTEzIDE2SDE0LjVWMTcuNUgxM1YxNlpNMTQuNSAxNy41SDE2VjE5SDE0LjVWMTcuNVpNMTYgMTZIMTcuNVYxNy41SDE2VjE2Wk0xNy41IDE0LjVIMTlWMTZIMTcuNVYxNC41Wk0xNy41IDE3LjVIMTlWMTlIMTcuNVYxNy41Wk0yMiA3SDIwVjRIMTdWMkgyMlY3Wk0yMiAyMlYxN0gyMFYyMEgxN1YyMkgyMlpNMiAyMkg3VjIwSDRWMTdIMlYyMlpNMiAyVjdINFY0SDdWMkgyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const QrCodeScanner = createIcon('QrCodeScanner', [
  [
    'path',
    {
      d: 'M9.5 6.5V9.5H6.5V6.5H9.5ZM11 5H5V11H11V5ZM9.5 14.5V17.5H6.5V14.5H9.5ZM11 13H5V19H11V13ZM17.5 6.5V9.5H14.5V6.5H17.5ZM19 5H13V11H19V5ZM13 13H14.5V14.5H13V13ZM14.5 14.5H16V16H14.5V14.5ZM16 13H17.5V14.5H16V13ZM13 16H14.5V17.5H13V16ZM14.5 17.5H16V19H14.5V17.5ZM16 16H17.5V17.5H16V16ZM17.5 14.5H19V16H17.5V14.5ZM17.5 17.5H19V19H17.5V17.5ZM22 7H20V4H17V2H22V7ZM22 22V17H20V20H17V22H22ZM2 22H7V20H4V17H2V22ZM2 2V7H4V4H7V2H2Z',
      key: '1bs5eq',
    },
  ],
]);

export default QrCodeScanner;
